const NoCopyWrapper = ({ children }) => {
  const handleEvent = (e) => {
    e.preventDefault();
  };
  return (
    <div onCopy={handleEvent} onCut={handleEvent} onContextMenu={handleEvent}>
      {children}
    </div>
  );
};

export default NoCopyWrapper;
